webpackJsonp([5],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flatStateGetters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_config_store__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_pages_store__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_measures_store__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_user_store__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_ui_store__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_load_status_store__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_search_store__ = __webpack_require__(100);












__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

var addTagToType_StorePlugin = function addTagToType_StorePlugin(store) {
  store.subscribe(function (mutation, state) {
    if (mutation.payload && mutation.payload.tag) {
      mutation.type = mutation.type + ' / ' + mutation.payload.tag;
    }
  });
};

var modules = {
  config: __WEBPACK_IMPORTED_MODULE_3__modules_config_store__["a" /* default */],
  pages: __WEBPACK_IMPORTED_MODULE_4__modules_pages_store__["a" /* default */],
  measures: __WEBPACK_IMPORTED_MODULE_5__modules_measures_store__["a" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_6__modules_user_store__["a" /* default */],
  ui: __WEBPACK_IMPORTED_MODULE_7__modules_ui_store__["a" /* default */],
  loadStatus: __WEBPACK_IMPORTED_MODULE_8__modules_load_status_store__["a" /* default */],
  search: __WEBPACK_IMPORTED_MODULE_9__modules_search_store__["a" /* default */]
};

var flatStateGetters = function flatStateGetters(modules) {
  var result = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(modules).forEach(function (moduleName) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(modules[moduleName].state).forEach(function (propName) {
      result[propName] = function (state) {
        return state[moduleName][propName];
      };
    });
  });
  return result;
};

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
  modules: modules,
  plugins: [addTagToType_StorePlugin],
  getters: flatStateGetters(modules)
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_auth_guard__ = __webpack_require__(103);
/* eslint-disable no-undef */





/* istanbul ignore next */
var Dashboard = function Dashboard(resolve) {
  new Promise(function(resolve) { resolve(); }).then((function () {
    resolve(__webpack_require__(24));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* istanbul ignore next */
var Validations = function Validations(resolve) {
  __webpack_require__.e/* require.ensure */(0).then((function () {
    resolve(__webpack_require__(89));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* istanbul ignore next */
var Referentials = function Referentials(resolve) {
  __webpack_require__.e/* require.ensure */(0).then((function () {
    resolve(__webpack_require__(88));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* istanbul ignore next */
var ReferentialsGraphComponent = function ReferentialsGraphComponent(resolve) {
  __webpack_require__.e/* require.ensure */(2).then((function () {
    resolve(__webpack_require__(86));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* istanbul ignore next */
var Clinics = function Clinics(resolve) {
  __webpack_require__.e/* require.ensure */(0).then((function () {
    resolve(__webpack_require__(87));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* istanbul ignore next */
var Tasks = function Tasks(resolve) {
  __webpack_require__.e/* require.ensure */(3).then((function () {
    resolve(__webpack_require__(90));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* istanbul ignore next */
var Login = function Login(resolve) {
  __webpack_require__.e/* require.ensure */(1).then((function () {
    resolve(__webpack_require__(91));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* istanbul ignore next */
var Profile = function Profile(resolve) {
  __webpack_require__.e/* require.ensure */(1).then((function () {
    resolve(__webpack_require__(92));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* istanbul ignore next */
var About = function About(resolve) {
  new Promise(function(resolve) { resolve(); }).then((function () {
    resolve(__webpack_require__(41));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};


/*
  Move this to main.js
  For testing, need to overwrite $route
  Ref: https://eddyerburgh.me/stub-$route-in-vue-unit-tests
*/
// Vue.use(VueRouter)

var routes = [{ path: '/', name: 'Home', component: Dashboard }, { path: '/dashboard', name: 'Dashboard', component: Dashboard }, { path: '/validations', name: 'Validations', component: Validations }, {
  path: '/referentials', name: 'Referentials', component: Referentials,
  children: [{ path: '/referentialsGraph', name: 'ReferentialsGraphComponent', component: ReferentialsGraphComponent }]
}, { path: '/clinics', name: 'Clinics', component: Clinics }, { path: '/tasks', name: 'Tasks', component: Tasks,
  beforeEnter: function beforeEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_3__user_auth_guard__["a" /* default */].canActivate()) {
      next();
    } else {
      next({ path: '/login?returnUrl=' + to.path + '&prompt=Team Tasks' });
    }
  }
}, { path: '/about', name: 'About', component: About }, { path: '/login', name: 'Login', component: Login,
  beforeEnter: function beforeEnter(to, from, next) {
    // This is required because dynamic path is not working
    var currentUser = __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].state.user.currentUser;
    if (currentUser) {
      next({ path: '/profile' });
    } else {
      next();
    }
  }
}, { path: '/profile', name: 'Profile', component: Profile }, { path: '*', redirect: '/dashboard' }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes,
  mode: 'history'
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
  __webpack_require__(166)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(215),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ff08768c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  getCountFilesForLastNDays: function getCountFilesForLastNDays(numDays, files) {
    return _getCountFilesForLastNDays(numDays, files);
  },
  filesByDate: function filesByDate(files) {
    return _filesByDate(files);
  }
});

var _getCountFilesForLastNDays = function _getCountFilesForLastNDays(numDays, files) {
  return _filesByDate(files).slice(0, numDays).map(function (group) {
    return group.files.length;
  }).reduce(function (total, num) {
    total += num;return total;
  }, 0);
};

var _filesByDate = function _filesByDate(files) {
  var keyFn = function keyFn(file) {
    return formatDate(file.effectiveDate);
  };
  return groupBy(files, keyFn).map(function (group) {
    return { date: group.key, files: group.group };
  });
};

var groupBy = function groupBy(arr, keyFn) {
  var grouped = arr.reduce(function (grouping, item) {
    var key = keyFn(item);
    grouping[key] = grouping[key] || [];
    grouping[key].push(item);
    return grouping;
  }, {});
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(grouped).map(function (key) {
    return { key: key, group: grouped[key] };
  });
};

var formatDate = function formatDate(date) {
  var d = new Date(date);
  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();
  var year = d.getFullYear();
  month = month.length < 2 ? '0' + month : month;
  day = day.length < 2 ? '0' + day : day;
  return [year, month, day].join('-');
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
  __webpack_require__(164)
  __webpack_require__(163)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(213),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-92b8fb28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_service__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__name_parsing_service__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_formatter_service__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_metric_service__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_html_service__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["a"] = ({
  checkAllFiles: function checkAllFiles() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([// eslint-disable-line no-undef
    this.checkFiles('validations'), this.checkFiles('referentials'), this.checkFiles('clinics')]);
  },
  checkFiles: function checkFiles(page) {
    return _checkFiles(page);
  },
  getFiles: function getFiles(page) {
    return _getFiles(page);
  },
  updateContent: function updateContent(fileType, numToInitialize) {
    return _updateContent(fileType, numToInitialize);
  },
  refreshFile: function refreshFile(fileType, fileInfo) {
    return _refreshFile(fileType, fileInfo);
  }
});

var _refreshFile = function _refreshFile(page, fileInfo) {
  getContent(page, fileInfo).then(function (fileInfo) {
    __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].commit('pages/SET_FILE', { page: page, fileInfo: fileInfo });
  });
};

var _checkFiles = function _checkFiles(page) {
  var files = __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.pages.files[page];
  if (!files || !files.length) {
    return __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].dispatch('waitForFetch', {
      resource: 'files/' + page,
      fetch: function fetch() {
        return _getFiles(page);
      }
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(); // eslint-disable-line no-undef
  }
};

var _updateContent = function _updateContent(fileType, numToInitialize) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all( // eslint-disable-line no-undef
  __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.pages.files[fileType].slice(0, numToInitialize).filter(function (file) {
    return !file.content;
  }).map(function (file) {
    return getContent(fileType, file);
  }));
};

var _getFiles = function _getFiles(page) {
  var filesPromise = __WEBPACK_IMPORTED_MODULE_1__file_service__["a" /* default */].getFileList().then(function (fileList) {
    var prefixes = __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.config[page + 'Config'].filePrefixes;
    var filesOfType = fileList.filter(function (file) {
      return prefixes.some(function (value) {
        return file.startsWith(value);
      });
    });
    return processFiles(filesOfType, page, prefixes);
  }).then(function (files) {
    var daysToDisplay = __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.config[page + 'Config'].daysToDisplay;
    __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].dispatch('pages/setFiles', { page: page, files: files, daysToDisplay: daysToDisplay });
  });
  return filesPromise;
};

var processFiles = function processFiles(fileList, fileType, filePrefixes) {
  if (!fileList.length) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(); // eslint-disable-line no-undef
  }
  var parsed = __WEBPACK_IMPORTED_MODULE_2__name_parsing_service__["a" /* default */].parseFiles(fileList, filePrefixes);
  var formatted = __WEBPACK_IMPORTED_MODULE_3__list_formatter_service__["a" /* default */].process(parsed);
  return setContentForList(fileType, formatted);
};

var setContentForList = function setContentForList(fileType, fileInfos) {
  var numToInitialize = __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.config[fileType + 'Config'].numToInitialize;
  var withContent = fileInfos.slice(0, numToInitialize).map(function (fileInfo) {
    return !fileInfo.content ? getContent(fileType, fileInfo) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(fileInfo);
  } // eslint-disable-line no-undef
  );
  var withoutContent = fileInfos.slice(numToInitialize).map(function (fileInfo) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(fileInfo);
  }); // eslint-disable-line no-undef
  var combined = withContent.concat(withoutContent);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(combined); // eslint-disable-line no-undef
};

var getContent = function getContent(fileType, fileInfo) {
  return __WEBPACK_IMPORTED_MODULE_1__file_service__["a" /* default */].getFile(fileInfo.name).then(function (response) {
    var date = response.headers ? response.headers.get('last-modified') : null;
    fileInfo.lastModified = date ? new Date(date) : null;
    fileInfo.lastRefresh = new Date();
    return processContent(fileType, response.body, fileInfo);
  });
};

var processContent = function processContent(fileType, content, fileInfo) {
  if (!content) {
    return fileInfo;
  }
  var id = 'dataContainer';
  var tempDiv = document.createElement('div');
  tempDiv.innerHTML = __WEBPACK_IMPORTED_MODULE_5__data_html_service__["a" /* default */].removeCommandTimeout(content);
  __WEBPACK_IMPORTED_MODULE_5__data_html_service__["a" /* default */].prefixStylesWithId(tempDiv, id);
  fileInfo.content = tempDiv.innerHTML;
  fileInfo.metric = __WEBPACK_IMPORTED_MODULE_4__data_metric_service__["a" /* default */].getMetric(fileType, tempDiv);
  fileInfo.badgeColor = __WEBPACK_IMPORTED_MODULE_4__data_metric_service__["a" /* default */].getBadgeColor(fileType, fileInfo.metric);
  return fileInfo;
};

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trimWithMask; });
var trimWithMask = function trimWithMask(theString, masks) {
  var s = theString.toString(); // Otherwise, can get a String object instead of a string primitive
  if (!Array.isArray(masks)) {
    masks = [masks];
  }
  masks.forEach(function (mask) {
    while (~mask.indexOf(s[0])) {
      s = s.slice(1);
    }
    while (~mask.indexOf(s[s.length - 1])) {
      s = s.slice(0, -1);
    }
  });
  return s;
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  getMetric: function getMetric(fileType, tempDiv) {
    return _getMetric(fileType, tempDiv);
  },
  getBadgeColor: function getBadgeColor(fileType, metric) {
    return _getBadgeColor(fileType, metric);
  }
});

var _getMetric = function _getMetric(fileType, tempDiv) {
  if (fileType === 'referentials') {
    return getReferentialsMetric(tempDiv);
  }
  if (fileType === 'validations') {
    return getValidationsMetric(tempDiv);
  }
  if (fileType === 'clinics') {
    return getClinicsMetric(tempDiv);
  }
};

var getValidationsMetric = function getValidationsMetric(tempDiv) {
  var total = 0;
  var elementsWithCount = tempDiv.getElementsByClassName('typeheader');
  for (var i = 0; i < elementsWithCount.length; ++i) {
    var countAsString = elementsWithCount[i].innerHTML.substr(1).split(' ')[0];
    var isnum = /^\d+$/.test(countAsString);
    if (isnum) {
      total += Number(countAsString);
    }
  }
  return total;
};

var getReferentialsMetric = function getReferentialsMetric(tempDiv) {
  var total = 0;
  var elementsWithColumnTotal = tempDiv.getElementsByClassName('columntotal');
  var totalAsString = elementsWithColumnTotal[3].innerHTML;
  var isnum = /^\d+$/.test(totalAsString);
  if (isnum) {
    total = Number(totalAsString);
  }
  return total;
};

var getClinicsMetric = function getClinicsMetric(tempDiv) {
  var totalErrors = 0;
  var elementsAffected = tempDiv.getElementsByClassName('columntotal affected');
  for (var i = 0; i < elementsAffected.length; i++) {
    totalErrors += getTotalFromElement(elementsAffected[i]);
  }

  var elementsActiveAppoints = tempDiv.getElementsByClassName('n active-appoints');
  var activeAppoints = elementsActiveAppoints.length === 0 ? 0 : getTotalFromElement(elementsActiveAppoints[0]);

  var percent = activeAppoints === 0 ? 0 : (activeAppoints - totalErrors) / activeAppoints * 100;
  return percent.toFixed(2) + '%';
};

var getTotalFromElement = function getTotalFromElement(element) {
  var total = 0;
  var totalAsString = element.innerHTML;
  var isnum = /^\d+$/.test(totalAsString);
  if (isnum) {
    total = Number(totalAsString);
  }
  return total;
};

var _getBadgeColor = function _getBadgeColor(fileType, metric) {
  if (fileType === 'referentials') {
    return metric === 0 ? 'green' : metric < 10 ? 'orange' : 'red';
  }
  if (fileType === 'validations') {
    return metric === 0 ? 'green' : metric < 10 ? 'orange' : 'red';
  }
  if (fileType === 'clinics') {
    var num = +metric.replace('%', '');
    return num >= 95 ? 'green' : num >= 75 ? 'orange' : 'red';
  }
  return 'gray';
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);


/* harmony default export */ __webpack_exports__["a"] = ({
  getFileList: function getFileList() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('filelist.txt').then(function (response) {
      var files = response.body.replace(/\r/, '').split(/\n/).map(function (file) {
        return file.trim();
      }).filter(function (file) {
        return !!file;
      });
      return files;
    }).catch(function (err) {
      return console.error('getFileList() failed', err);
    });
  },
  getFile: function getFile(fileName) {
    var url = fileName.trim() + '.html';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(url).then(function (response) {
      return response;
    }).catch(function (err) {
      return console.error('getFile() failed', err);
    });
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__files_by_date_service__ = __webpack_require__(28);

// import { store } from '../store/store'


/* harmony default export */ __webpack_exports__["a"] = ({
  clinicsHistory: function clinicsHistory(files) {
    var data = files.filter(function (f) {
      return f.metric;
    }).map(function (f) {
      return +f.metric.replace('%', '');
    });
    var min = Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
    var history = data.map(function (d) {
      return +(d - min + 1).toFixed(4);
    }).reverse();
    return history;
  },
  validationsHistory: function validationsHistory(files) {
    return files.filter(function (f) {
      return f.metric;
    }).map(function (f) {
      return f.metric;
    }).reverse();
  },
  referentialsHistory: function referentialsHistory(files) {
    return __WEBPACK_IMPORTED_MODULE_1__files_by_date_service__["a" /* default */].filesByDate(files).map(function (x) {
      return x.files.reduce(function (total, file) {
        return total + (file.metric || 0);
      }, 0);
    }).reverse();
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_masked_trim__ = __webpack_require__(49);


/* harmony default export */ __webpack_exports__["a"] = ({
  process: function process(files) {
    return _process(files);
  }
});

var _process = function _process(files) {
  files.sort(fileInfoComparer);
  sequenceDisplay(files);
  return files;
};

var fileInfoComparer = function fileInfoComparer(a, b) {
  if (!a.effectiveDate || !b.effectiveDate) {
    throw new Error('Effective dates not valid. a: ' + a + ', b: ' + b);
  }
  return a.effectiveDate > b.effectiveDate ? -1 // Latest date on top
  : a.effectiveDate < b.effectiveDate ? 1 : a.namePrefix < b.namePrefix ? -1 // then sort by name prefix to keep similar files together
  : a.namePrefix > b.namePrefix ? 1 : a.effectiveTime > b.effectiveTime ? -1 // then the latest time (version)
  : a.effectiveTime < b.effectiveTime ? 1 : 0;
};

var sequenceDisplay = function sequenceDisplay(files) {
  return files.reduce(function (previous, current) {
    sequencer(previous, current);return current;
  }, null);
};

var sequencer = function sequencer(previous, current) {
  current.sequenceNo = getSequenceNo(previous, current);
  setDisplayName(current);
  return current;
};

var getSequenceNo = function getSequenceNo(previous, current) {
  if (!previous || !current || !current.effectiveTime) {
    return 0;
  }
  if (!hasSameFileNameAndDate(previous, current)) {
    return 0;
  }
  return previous.sequenceNo + 1;
};

var hasSameFileNameAndDate = function hasSameFileNameAndDate(previous, current) {
  return previous.baseName === current.baseName && previous.effectiveDate.getTime() === current.effectiveDate.getTime();
};

var setDisplayName = function setDisplayName(fileInfo) {
  fileInfo.displayName = removeTimeFromDisplayName(fileInfo);

  if (fileInfo.sequenceNo === undefined || fileInfo.sequenceNo < 0) {
    return;
  }

  if (fileInfo.sequenceNo > 0) {
    fileInfo.displayName = '...';
  }
};

var removeTimeFromDisplayName = function removeTimeFromDisplayName(fileInfo) {
  if (!fileInfo.effectiveTime) {
    return fileInfo.name;
  }
  var timeAsInFileName = fileInfo.effectiveTime.replace(':', '.');
  var timePos = fileInfo.name.indexOf(timeAsInFileName);
  return timePos !== -1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_masked_trim__["a" /* trimWithMask */])(fileInfo.name.replace(' - ' + timeAsInFileName, ''), '- ') : fileInfo.name;
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_masked_trim__ = __webpack_require__(49);



/* harmony default export */ __webpack_exports__["a"] = ({
  parseFiles: function parseFiles(files, prefixes) {
    return _parseFiles(files, prefixes);
  }
});

var _parseFiles = function _parseFiles(files, prefixes) {
  return files.map(function (file) {
    return parseFile(file, prefixes);
  });
};

var parseFile = function parseFile(file, prefixes) {
  var fileInfo = {
    name: parseFileName(file),
    namePrefix: '',
    baseName: getBaseName(file),
    displayName: '',
    effectiveDate: parseEffectiveDate(file),
    effectiveTime: parseEffectiveTime(file),
    lastRefresh: new Date()
  };
  fileInfo.namePrefix = prefixes.find(function (pref) {
    return fileInfo.name.startsWith(pref);
  });
  fileInfo.displayName = fileInfo.name;
  return fileInfo;
};

var parseFileName = function parseFileName(fileName) {
  return fileName.replace('.html', '');
};

var getBaseName = function getBaseName(fileName) {
  var month = findMonth(fileName);
  if (!month.found) {
    return fileName;
  }
  var base = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_masked_trim__["a" /* trimWithMask */])(fileName.substr(0, month.pos - 4), '( ');
  return base;
};

var findMonth = function findMonth(fileName) {
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var words = fileName.split(' ');
  var month = { pos: -1, number: -1, found: false };
  var monthIndex = -1;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(words), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var word = _step.value;

      monthIndex = months.indexOf(word);
      if (monthIndex > -1) {
        month.number = monthIndex;
        month.pos = fileName.indexOf(months[monthIndex]);
        month.found = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return month;
};

var parseEffectiveDate = function parseEffectiveDate(fileName) {
  var month = findMonth(fileName);
  if (month.found) {
    var day = parseInt(fileName.substr(month.pos - 3, 2), 0);
    var year = parseInt(fileName.substr(month.pos + 4, 4), 0);
    return new Date(year, month.number, day);
  }
  return null;
};

var parseEffectiveTime = function parseEffectiveTime(fileName) {
  var time = fileName.match(/\d\d\.\d\d/);
  if (!time) {
    return '';
  }
  return time[0].replace('.', ':');
};

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = awaitDevtools;
/* harmony export (immutable) */ __webpack_exports__["b"] = refreshDevtools;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

// Ref: https://github.com/vuejs/vue-devtools/issues/124
//      https://gist.github.com/rtfleg/cc159e4f773a8a3d9ec3a0f8ca821464

var promise = null;

/**
 * Returns promise which resolves after devtools ready state became determined (see awaitDevtoolsImpl below).
 * @param {number} [timeout] - devtools ready state detection timeout (one second by default).
 * @returns {Promise.<boolean|null>}
 */
function awaitDevtools(timeout) {
  /* istanbul ignore next */
  return promise || (promise = awaitDevtoolsImpl(timeout || 1000));
}

/**
 * Refreshes devtools, useful if you bootstrap app inside callback of the promise which returned by awaitDevtools.
 * Call that function after app bootstrapped in order to deal with missing component tree and so on.
 */
function refreshDevtools() {
  /* istanbul ignore next */
  window.postMessage({ source: 'vue-devtools-proxy', payload: 'refresh' }, '*');
}

/**
 * Returns promise which resolves after devtools ready state became determined.
 * This promise will be resolved in any case (we need to bootstrap app after all) except some internal error happens.
 *
 * Possible promise results are:
 *  - false - devtools are not available at the moment (good);
 *  - true - devtools are available and ready (good);
 *  - null - unable to determine devtools ready state (bad, some commits might be not reflected in devtools).
 *
 * NOTE:
 * Function will work only in case devtools tab is opened before page load, in opposite case it's useless.
 * So, if you have problems with it, then switch to devtools tab and refresh the page.
 *
 * @param {number} timeout - devtools ready state detection timeout.
 * @returns {Promise.<boolean|null>}
 */
function awaitDevtoolsImpl(timeout) {
  /* istanbul ignore next */
  if (!window['__VUE_DEVTOOLS_GLOBAL_HOOK__']) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
  }

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    window.addEventListener('message', onMessage, false);
    var timeoutId = setTimeout(function () {
      return onTimeout();
    }, timeout);

    function onMessage(e) {
      if (isReadyMessage(e)) {
        clearTimeout(timeoutId);
        resolve(true);
      }
    }

    function onTimeout() {
      window.removeEventListener('message', onMessage);
      resolve(null);
    }

    function isReadyMessage(e) {
      return e && e.data && e.data.source === 'vue-devtools-backend' && e.data.payload && e.data.payload.event === 'ready';
    }
  });
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_inject__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_config_service__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_data_service__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_measure_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_file_service__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_name_parsing_service__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_list_formatter_service__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_files_by_date_service__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__history_service__ = __webpack_require__(52);













__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.service('fileService', function () {
  return __WEBPACK_IMPORTED_MODULE_4__services_file_service__["a" /* default */];
});
__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.service('nameParsingService', function () {
  return __WEBPACK_IMPORTED_MODULE_5__services_name_parsing_service__["a" /* default */];
});
__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.service('listFormatterService', function () {
  return __WEBPACK_IMPORTED_MODULE_6__services_list_formatter_service__["a" /* default */];
});
__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.service('filesByDateService', function () {
  return __WEBPACK_IMPORTED_MODULE_7__services_files_by_date_service__["a" /* default */];
});

__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.service('historyService', function () {
  return __WEBPACK_IMPORTED_MODULE_8__history_service__["a" /* default */];
});

__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.service('configService', function () {
  return __WEBPACK_IMPORTED_MODULE_1__services_config_service__["a" /* default */];
});
__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.service('dataService', ['fileService', 'nameParsingService', 'listFormatterService', 'filesByDateService'], function () {
  return __WEBPACK_IMPORTED_MODULE_2__services_data_service__["a" /* default */];
});
__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.service('measureService', ['historyService'], function () {
  return __WEBPACK_IMPORTED_MODULE_3__services_measure_service__["a" /* default */];
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
  __webpack_require__(158)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(210),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(214),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(209),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44ab7880",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  checkConfig: function checkConfig() {
    return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].dispatch('waitForFetch', {
      resource: 'config',
      fetch: this.getConfig
    });
  },
  getConfig: function getConfig() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('migration-workbench.config.json').then(function (response) {
      var config = response.body;
      setNumToInitialize(config);
      setNumToDisplay(config);
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('SET_CONFIG', config);
    });
  }
});

var setNumToInitialize = function setNumToInitialize(config) {
  config.validationsConfig.numToInitialize = config.validationsConfig.numDataPointsForSparkline;
  config.clinicsConfig.numToInitialize = config.clinicsConfig.numDataPointsForSparkline;
  config.referentialsConfig.numToInitialize = config.referentialsConfig.daysToInitialize * config.referentialsConfig.filePrefixes.length;
};

var setNumToDisplay = function setNumToDisplay(config) {
  config.referentialsConfig.numInitialFilesToDisplay = config.referentialsConfig.daysToDisplay * config.referentialsConfig.filePrefixes.length;
  ['validations', 'referentials', 'clinics'].forEach(function (fileType) {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('pages/UPDATE_NUMVISIBLE', {
      page: fileType,
      tag: fileType,
      numVisible: config[fileType + 'Config'].numInitialFilesToDisplay
    });
  });
};

// const getNumToInitialize = (files, fileType) => {
//   if (fileType === 'validations') {
//     return store.state.config.validationsConfig.numDataPointsForSparkline;
//   }
//   if (fileType === 'clinics') {
//     return store.state.config.clinicsConfig.numDataPointsForSparkline;
//   }
//   if (fileType === 'referentials') {
//     const daysToInitialize = store.state.config.referentialsConfig.daysToInitialize
//     const filesToInit = getCountFilesForLastNDays(daysToInitialize, files)
//     return filesToInit
//   }
// }

// const getCountFilesForLastNDays = (numDays, files) => {
//   return filesByDateService.filesByDate(files)
//     .slice(0, numDays)
//     .map(group => group.files.length)
//     .reduce((total, num) => { total += num; return total; }, 0 );
// }

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_media_query__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__awaitdevtools_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toasted__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_inject__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__about_foldable_VueFoldable__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__about_foldable_VueFoldable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__about_foldable_VueFoldable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__about_foldable_vue_foldable_css__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__about_foldable_vue_foldable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__about_foldable_vue_foldable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_routes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dashboard_Dashboard__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dashboard_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__dashboard_Dashboard__);









__webpack_require__(74);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = './static/data/';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_toasted___default.a, {
  position: 'top-right'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_media_query___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_inject___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('foldable', __WEBPACK_IMPORTED_MODULE_9__about_foldable_VueFoldable___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('mwb-dashboard', __WEBPACK_IMPORTED_MODULE_14__dashboard_Dashboard___default.a);

// Ref: https://github.com/vuejs/vue-devtools/issues/124
//      https://gist.github.com/rtfleg/cc159e4f773a8a3d9ec3a0f8ca821464
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__awaitdevtools_js__["a" /* awaitDevtools */])().then(bootstrapApp).then(__WEBPACK_IMPORTED_MODULE_6__awaitdevtools_js__["b" /* refreshDevtools */]); // Refresh is required in order to deal with missing component tree and another issues.

function bootstrapApp() {
  /* eslint-disable no-new */
  var myApp = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: "#app",
    store: __WEBPACK_IMPORTED_MODULE_13__store_store__["a" /* store */],
    router: __WEBPACK_IMPORTED_MODULE_12__router_routes__["a" /* default */],
    template: '<App/>',
    components: {
      App: __WEBPACK_IMPORTED_MODULE_11__App___default.a
    },
    created: function created() {
      // Dispatch some actions or make some commits here.
      // All the store changes will be reflected inside devtools :-)
    }
  });
  if (window.Cypress) {
    // add this ref to give Cypress tests access to the root app
    window.myApp = myApp;
  }
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  prefixStylesWithId: function prefixStylesWithId(tempDiv, id) {
    return _prefixStylesWithId(tempDiv, id);
  },
  removeCommandTimeout: function removeCommandTimeout(content) {
    return _removeCommandTimeout(content);
  }
});

var _prefixStylesWithId = function _prefixStylesWithId(tempDiv, id) {
  var styleSections = tempDiv.getElementsByTagName('style');

  var _loop = function _loop(i) {
    var styles = styleSections[i];
    var styleLines = styles.innerHTML.split(/\r?\n/);
    var newStyles = [];
    styleLines.forEach(function (line) {
      if (line.indexOf('{') !== -1) {
        line = '#' + id + ' ' + line;
        line = replaceAll(line, ',', ', #' + id);
      }
      newStyles.push(line);
    });
    styles.innerHTML = newStyles.join('\n');
  };

  for (var i = 0; i < styleSections.length; ++i) {
    _loop(i);
  }
};

var _removeCommandTimeout = function _removeCommandTimeout(content) {
  var searchFor = /Command[\s]+Timeout[\s]+only[\s]+supported[\s]+by[\s]+SQL[\s]+Client[\s]+\(so[\s]+far\)<br\/>/;
  var regex = new RegExp(searchFor, 'g');
  return content.replace(regex, '');
};

var replaceAll = function replaceAll(theString, search, replace) {
  return theString.replace(new RegExp(escapeRegExp(search), 'g'), replace);
};

var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\$&'); // $& means the whole matched string
};

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history_service__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_data_metric_service__ = __webpack_require__(50);





/* harmony default export */ __webpack_exports__["a"] = ({
  checkMeasures: function checkMeasures() {
    return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].dispatch('waitForFetch', {
      resource: 'measures',
      fetch: this.getMeasures
    });
  },
  getMeasures: function getMeasures() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('InitialMeasures.json').then(function (response) {
      return response.json();
    }).catch(function (err) {
      return console.error('getMeasures() failed response', err);
    }).then(function (data) {
      data.measures.forEach(function (measure) {
        measure.history = measure.history || []; // Ensure property for reactive update
      });
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('SET_MEASURES', data.measures);
    }).catch(function (err) {
      return console.error('getMeasures() failed data', err);
    });
  },
  updateMeasures: function updateMeasures() {
    var measures = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.measures.measures;
    var files = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.pages.files;
    updateValidationsMeasure(measures, files);
    updateReferentialsMeasure(measures, files);
    updateClinicsMeasure(measures, files);
  }
});

var updateValidationsMeasure = function updateValidationsMeasure(measures, files) {
  if (!files.validations || !files.validations.length) return;
  var first = files.validations[0];
  var badgeColor = __WEBPACK_IMPORTED_MODULE_3__services_data_metric_service__["a" /* default */].getBadgeColor('validations', first.metric);
  var payload = {
    measure: {
      id: 'validations',
      metric: first.metric,
      color: badgeColor,
      history: __WEBPACK_IMPORTED_MODULE_2__history_service__["a" /* default */].validationsHistory(files.validations)
    },
    tag: 'validations'
  };
  __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('UPDATE_MEASURE', payload);
};

var updateReferentialsMeasure = function updateReferentialsMeasure(measures, files) {
  if (!files.referentials || !files.referentials.length) return;
  var history = __WEBPACK_IMPORTED_MODULE_2__history_service__["a" /* default */].referentialsHistory(files.referentials);
  var metric = history[history.length - 1];
  var badgeColor = __WEBPACK_IMPORTED_MODULE_3__services_data_metric_service__["a" /* default */].getBadgeColor('referentials', metric);
  var payload = {
    measure: {
      id: 'referentials',
      metric: metric,
      color: badgeColor,
      history: history
    },
    tag: 'referentials'
  };
  __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('UPDATE_MEASURE', payload);
};

var updateClinicsMeasure = function updateClinicsMeasure(measures, files) {
  if (!files.clinics || !files.clinics.length) return;
  var first = files.clinics[0];
  var badgeColor = __WEBPACK_IMPORTED_MODULE_3__services_data_metric_service__["a" /* default */].getBadgeColor('clinics', first.metric);
  var payload = {
    measure: {
      id: 'clinics',
      metric: first.metric,
      color: badgeColor,
      history: __WEBPACK_IMPORTED_MODULE_2__history_service__["a" /* default */].clinicsHistory(files.clinics)
    },
    tag: 'clinics'
  };
  __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('UPDATE_MEASURE', payload);
};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */

var state = {
  baseDataUrl: '',
  clinicsConfig: {
    filePrefixes: [],
    numDataPointsForSparkline: 10,
    numInitialFilesToDisplay: 3,
    page: {
      pageTitle: '',
      pageDescription: '',
      listTitle: '',
      listWidth: 0,
      badgeUnits: '',
      resultsZoom: ''
    }
  },
  validationsConfig: {
    filePrefixes: [],
    numDataPointsForSparkline: 10,
    numInitialFilesToDisplay: 3,
    page: {
      pageTitle: '',
      pageDescription: '',
      listTitle: '',
      listWidth: 0,
      badgeUnits: '',
      resultsZoom: ''
    }
  },
  referentialsConfig: {
    filePrefixes: [],
    daysToInitialize: 0,
    daysToDisplay: 0,
    page: {
      pageTitle: '',
      pageDescription: '',
      listTitle: '',
      listWidth: 0,
      badgeUnits: '',
      resultsZoom: ''
    }
  }
};

var mutations = {
  'SET_CONFIG': function SET_CONFIG(state, payload) {
    state.baseDataUrl = payload.baseDataUrl;
    state.clinicsConfig = payload.clinicsConfig;
    state.referentialsConfig = payload.referentialsConfig;
    state.validationsConfig = payload.validationsConfig;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */
/* unused harmony export actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(5);




var state = {};

var mutations = {
  'ON_FETCHING': function ON_FETCHING(state, payload) {
    state[payload.resource] = payload.status;
  },
  'ON_FETCH': function ON_FETCH(state, payload) {
    state[payload.resource] = payload.status;
  },
  'ON_FAIL': function ON_FAIL(state, payload) {
    state[payload.resource] = payload.status;
  }
};

var actions = {
  waitForFetch: function waitForFetch(context, _ref) {
    var resource = _ref.resource,
        fetch = _ref.fetch,
        fail = _ref.fail,
        timeout = _ref.timeout;

    return isLoaded(context.state, resource) ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('already loaded') // eslint-disable-line no-undef
    : isInitial(context.state, resource) ? doFetch(resource, fetch, fail) : isLoading(context.state, resource) ? doWaitForLoading(context.state, resource, timeout) : null;
  }
};

var doFetch = function doFetch(resource, fetch, fail) {
  if (!fetch) {
    throw new Error('Error: no fetch method was passed in for resource: ' + resource);
  }
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('ON_FETCHING', { resource: resource, status: 'loading' });
  var t0 = Date.now(); // performance.now();
  var fetchPromise = fetch();
  fetchPromise.then(function (_) {
    return onFetched(resource, t0);
  }).catch(function (error) {
    return onFail(resource, fail, error);
  });
  return fetchPromise;
};

var onFetched = function onFetched(resource, t0) {
  var t1 = Date.now();
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('ON_FETCH', { resource: resource, status: 'loaded ' + Math.round(t1 - t0) + ' ms' });
};

var onFail = function onFail(resource, fail, error) {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('ON_FAIL', { resource: resource, status: 'failed - error: ' + error.message });
  if (fail) {
    fail();
  }
};

var doWaitForLoading = function doWaitForLoading(state, resource, timeout) {
  timeout = timeout || 3000;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    // eslint-disable-line no-undef
    setTimeout(function () {
      if (isLoaded(state, resource)) {
        resolve('loaded'); // Inform the waiter of success
      } else {
        reject('failed'); // Inform the waiter of failure
      }
    }, timeout);
  });
};

var isInitial = function isInitial(state, resource) {
  return !state[resource] || state[resource] !== 'loading' && !state[resource].startsWith('loaded');
};

var isLoaded = function isLoaded(state, resource) {
  return state[resource] && state[resource].startsWith('loaded');
};

var isLoading = function isLoading(state, resource) {
  return state[resource] === 'loading';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);



var state = {
  measures: []
};

var mutations = {
  'SET_MEASURES': function SET_MEASURES(state, payload) {
    state.measures = payload;
  },
  'UPDATE_MEASURE': function UPDATE_MEASURE(state, payload) {
    var measureIndex = state.measures.findIndex(function (measure) {
      return measure.id === payload.measure.id;
    });
    if (measureIndex > -1) {
      // Vue.set to ensure new array items are observable
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.measures, measureIndex, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.measures[measureIndex], payload.measure));
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.measures[measureIndex], 'status', 'updated');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getters */
/* unused harmony export mutations */
/* unused harmony export actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_data_service__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_files_by_date_service__ = __webpack_require__(28);



var state = {
  files: {
    validations: [],
    referentials: [],
    clinics: []
  },
  selected: {
    validations: 0,
    referentials: 0,
    clinics: 0
  },
  numVisible: {
    validations: 5,
    referentials: 5,
    clinics: 5
  }
};

var getters = {
  visibleFiles: function visibleFiles(state) {
    return function (page) {
      var numVisible = state.numVisible[page] || 0;
      var files = state.files[page];
      return files ? files.slice(0, numVisible) : [];
    };
  },
  fileInfo: function fileInfo(state) {
    return function (page) {
      var selected = state.selected[page];
      var files = state.files[page];
      return files[selected];
    };
  }
};

var mutations = {
  'SET_FILES': function SET_FILES(state, payload) {
    state.files[payload.page] = payload.files;
  },
  'UPDATE_NUMVISIBLE': function UPDATE_NUMVISIBLE(state, payload) {
    state.numVisible[payload.page] = payload.numVisible;
  },
  'UPDATE_SELECTED': function UPDATE_SELECTED(state, payload) {
    state.selected[payload.page] = payload.index;
  },
  'SET_FILE': function SET_FILE(state, payload) {
    var index = state.files[payload.page].indexOf(function (fileInfo) {
      return fileInfo.name === payload.fileInfo.name;
    });
    if (index > -1) {
      state.files[payload.page] = payload.fileInfo;
    }
  }
};

var actions = {
  updateNumVisible: function updateNumVisible(context, payload) {
    __WEBPACK_IMPORTED_MODULE_0__services_data_service__["a" /* default */].updateContent(payload.page, payload.numVisible).then(function (_) {
      context.commit('UPDATE_NUMVISIBLE', payload);
    });
  },
  setFiles: function setFiles(context, _ref) {
    var page = _ref.page,
        files = _ref.files,
        daysToDisplay = _ref.daysToDisplay;

    if (page === 'referentials') {
      var numFilesToDisplay = __WEBPACK_IMPORTED_MODULE_1__services_files_by_date_service__["a" /* default */].getCountFilesForLastNDays(daysToDisplay, files);
      context.commit('UPDATE_NUMVISIBLE', { page: page, tag: page, numVisible: numFilesToDisplay });
    }
    context.commit('SET_FILES', { page: page, files: files });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */
/* unused harmony export getters */

var state = {
  searchTerm: '',
  matchCount: 0,
  results: []
};

var mutations = {
  'SET_RESULTS': function SET_RESULTS(state, payload) {
    state.results = payload;
  },
  'SET_SEARCHTERM': function SET_SEARCHTERM(state, payload) {
    state.searchTerm = payload;
  },
  'SET_MATCHCOUNT': function SET_MATCHCOUNT(state, payload) {
    state.matchCount = payload;
  }
};

var getters = {
  searchResultForFile: function searchResultForFile(state) {
    return function (fileName) {
      return state.results.find(function (r) {
        return r.file.name === fileName;
      });
    };
  },
  searchResultsCountForFile: function searchResultsCountForFile(state) {
    return function (fileName) {
      var resultsForFile = state.results.find(function (r) {
        return r.file.name === fileName;
      });
      return resultsForFile ? resultsForFile.count : 0;
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */

var state = {
  docsPanelIsOpen: false
};

var mutations = {
  'TOGGLE_DOCS_PANEL': function TOGGLE_DOCS_PANEL(state) {
    state.docsPanelIsOpen = !state.docsPanelIsOpen;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */

var state = {
  users: [],
  currentUser: null
};

var mutations = {
  'SET_USERS': function SET_USERS(state, payload) {
    state.users = payload.users;
  },
  'SET_CURRENT_USER': function SET_CURRENT_USER(state, payload) {
    state.currentUser = payload;
  },
  'UPDATE_USER': function UPDATE_USER(state, payload) {
    var user = state.users.find(function (user) {
      return user.id === payload.id;
    });
    if (user) {
      user.firstName = payload.firstName;
      user.lastName = payload.lastName;
      user.password = payload.password;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_routes__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = ({
  canActivate: function canActivate() {
    if (__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.user.currentUser) {
      return true;
    }
    __WEBPACK_IMPORTED_MODULE_1__router_routes__["a" /* default */].push('/login');
    return false;
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_Nav__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nav_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__about_About__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__about_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__about_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_routes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_splitter_Splitter__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_splitter_Splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_splitter_Splitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debounce__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    "mwb-navigation": __WEBPACK_IMPORTED_MODULE_0__nav_Nav___default.a,
    "mwb-about": __WEBPACK_IMPORTED_MODULE_1__about_About___default.a,
    splitter: __WEBPACK_IMPORTED_MODULE_3__common_splitter_Splitter___default.a
  },
  data: function data() {
    return {
      docsPanelStyle: { zoom: 33 + 50 + "%", height: "100vh" },
      splitterConfig: {
        minPanelLeft: 20,
        minPanelRight: 50,
        startPanelLeft: 50
      }
    };
  },

  computed: {
    docsPanelIsOpen: function docsPanelIsOpen() {
      return this.$store.state.ui.docsPanelIsOpen;
    }
  },
  methods: {
    onResize: __WEBPACK_IMPORTED_MODULE_4_debounce___default()(function (x) {
      this.docsPanelStyle = { zoom: x + 50 + "%" };
    }, 300)
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "about",
  data: function data() {
    return {
      docs: ["overview.html", "code-coverage.html", "cypress-e2e-tests.html", "measure-calculation.html", "dashboard-thumbnail.html", "narrative-dropdown-panel.html", "scrollbar-css-adjustments.html", "bootstrap-collapse-in-vue.html", "search.component-tests.html", "issues.html", "npm-audit.html"],
      currentDoc: null
    };
  },
  created: function created() {
    this.structureDocs();
    this.docs.forEach(this.loadDoc);
  },

  methods: {
    structureDocs: function structureDocs() {
      this.docs = this.docs.map(function (name) {
        return { name: name, html: "", isCollapsed: true };
      });
    },
    loadDoc: function loadDoc(doc) {
      var url = "../docs/" + doc.name;
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(url).then(function (response) {
        doc.html = response.body;
      }).catch(function (err) {
        return console.error("getFile() failed", err);
      });
    },
    selectDoc: function selectDoc(index, event) {
      this.docs[index].isCollapsed = event.isCollapsed;
      this.scrollToTopWhenCollapsing(event.isCollapsed, index);
      this.setCurrentDoc(event.isCollapsed, index);
    },
    scrollToTopWhenCollapsing: function scrollToTopWhenCollapsing(isCollapsed, index) {
      if (isCollapsed) {
        var docDiv = this.$el.querySelector("#doc" + index);
        docDiv.scrollTop = 0;
      }
    },
    setCurrentDoc: function setCurrentDoc(isCollapsed, index) {
      if (!isCollapsed) {
        this.currentDoc = this.docs[index];
      }
    },
    closeDoc: function closeDoc() {
      this.currentDoc.isCollapsed = true;
      this.currentDoc = null;
    }
  },
  computed: {
    allCollapsed: function allCollapsed() {
      return !this.docs.some(function (d) {
        return d.isCollapsed;
      });
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueIcon_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VueIcon_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var DEFAULT_VISUAL_HEIGHT = 100;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "vue-foldable",

  components: { VueIcon: __WEBPACK_IMPORTED_MODULE_0__VueIcon_vue___default.a },

  props: {
    minHeight: {
      type: Number,
      default: DEFAULT_VISUAL_HEIGHT
    },

    height: {
      type: [Number, String],
      default: DEFAULT_VISUAL_HEIGHT
    },

    once: {
      type: Boolean,
      default: false
    },

    async: {
      type: Boolean,
      default: false
    },

    timeout: {
      type: Number,
      default: 3000
    },

    noMask: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    var height = this.height;
    if (typeof this.height === "number" && this.height < this.minHeight) {
      height = this.minHeight;
    }
    return {
      collapsed: true,
      currentMaxHeight: height,
      threshold: height,
      reachThreshold: true,
      percentageMode: typeof this.height === "string" && this.height.indexOf("%") !== -1,
      percentage: null
    };
  },
  created: function created() {
    if (typeof this.height === "string" && !this.percentageMode) {
      this.currentMaxHeight = this.threshold = DEFAULT_VISUAL_HEIGHT;
    }
    if (this.percentageMode) {
      this.percentage = parseInt(this.threshold.replace("%", "").trim()) / 100;
    }
  },
  mounted: function mounted() {
    this.handleMount();
    // Temporary hack since this.$nextTick still cannot ensure all the sub components rendered.
    // See: https://vuejs.org/v2/api/#mounted
    setTimeout(this.handleMount, 50);
    // this.$nextTick(function () {
    //     this.handleMount()
    // })
    if (this.async) {
      onElementHeightChange({
        el: this.$refs.container,
        callback: this.handleMount,
        timeout: this.timeout
      });
    }
  },


  methods: {
    handleMount: function handleMount() {
      if (!this.$refs.container) {
        return;
      }
      var contentHeight = this.$refs.container.scrollHeight;
      this.calculateThreshold(contentHeight);
      this.checkReachThresfold(contentHeight);
    },
    checkReachThresfold: function checkReachThresfold(contentHeight) {
      this.reachThreshold = contentHeight > this.threshold;
    },
    calculateThreshold: function calculateThreshold(contentHeight) {
      if (this.percentageMode) {
        var calculatedHeight = contentHeight * this.percentage;
        if (calculatedHeight < this.minHeight) {
          calculatedHeight = this.minHeight;
        }
        this.currentMaxHeight = calculatedHeight;
        this.threshold = calculatedHeight;
      }
    },
    toggle: function toggle() {
      this.collapsed = !this.collapsed;
      if (this.collapsed) {
        this.currentMaxHeight = this.threshold;
      } else {
        // explicitly set max height so that it can be transitioned
        this.currentMaxHeight = this.$refs.container.scrollHeight;
        if (this.once) {
          this.reachThreshold = false;
        }
      }
      this.$emit("toggle", { isCollapsed: this.collapsed });
    }
  }
});

function onElementHeightChange(_ref) {
  var el = _ref.el,
      callback = _ref.callback,
      timeout = _ref.timeout;

  var oldHeight = el.scrollHeight,
      newHeight = void 0;
  var poller = void 0;
  var interval = 100;
  var count = 0;
  var maxCount = timeout / interval;

  function unit() {
    count++;
    newHeight = el.scrollHeight;
    if (oldHeight !== newHeight) {
      callback(newHeight);
      if (poller) {
        clearTimeout(poller);
      }
    }
    oldHeight = newHeight;
    if (count <= maxCount) {
      poller = setTimeout(unit, interval);
    }
  }

  unit();
}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: { type: Object, required: true },
    units: { type: String, default: '' }
  },
  data: function data() {
    return {
      isExpanded: false
    };
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Ref: https://github.com/rmp135/vue-splitter
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    config: {
      startPanelLeft: {
        type: Number,
        default: 50
      },
      minPanelLeft: {
        type: Number,
        default: 10
      },
      minPanelRight: {
        type: Number,
        default: 10
      },
      horizontal: {
        type: Boolean,
        default: false
      }
    },
    showLeft: {
      type: Boolean,
      default: true
    },
    showRight: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.percent = this.config.startPanelLeft;
  },
  data: function data() {
    return {
      active: false,
      percent: this.startPanelLeft,
      hasMoved: false
    };
  },

  computed: {
    flexDirection: function flexDirection() {
      return this.config.horizontal ? "column" : "row";
    },
    splitterStyle: function splitterStyle() {
      return this.config.horizontal ? { height: "5px", cursor: "ns-resize" } : { width: "5px", cursor: "ew-resize" };
    },
    leftPaneStyle: function leftPaneStyle() {
      var percent = this.showRight ? this.percent : 100;
      return this.config.horizontal ? { height: "100%" } : { width: percent + "%" };
    },
    rightPaneStyle: function rightPaneStyle() {
      var percent = this.showLeft ? this.percent : 0;
      return this.config.horizontal ? { height: 100 - percent + "%" } : { width: 100 - percent + "%" };
    },
    userSelect: function userSelect() {
      return this.active ? "none" : "";
    },
    cursor: function cursor() {
      return this.active ? this.config.horizontal ? "ns-resize" : "ew-resize" : "";
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.hasMoved) {
        this.percent = this.config.startPanelLeft;
        this.$emit("resize", this.percent);
      }
    },
    onDown: function onDown(e) {
      this.active = true;
      this.hasMoved = false;
    },
    onUp: function onUp() {
      this.active = false;
    },
    onMove: function onMove(e) {
      var offset = 0;
      var target = e.currentTarget;
      var percent = 0;
      if (this.active) {
        if (this.config.horizontal) {
          while (target) {
            offset += target.offsetTop;
            target = target.offsetParent;
          }
          percent = Math.floor((e.pageY - offset) / e.currentTarget.offsetHeight * 10000) / 100;
        } else {
          while (target) {
            offset += target.offsetLeft;
            target = target.offsetParent;
          }
          percent = Math.floor((e.pageX - offset) / e.currentTarget.offsetWidth * 10000) / 100;
        }
        if (percent > this.config.minPanelLeft && percent < 100 - this.config.minPanelRight) {
          this.percent = percent;
        }
        this.$emit("resize", this.percent);
        this.hasMoved = true;
      }
    },
    onMouseMove: function onMouseMove(e) {
      if (e.buttons === 0 || e.which === 0) {
        this.active = false;
      }
      this.onMove(e);
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DashboardThumbnail_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DashboardThumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DashboardThumbnail_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  dependencies: ['dataService', 'configService', 'measureService'],
  data: function data() {
    return {
      title: 'Dashboard'
    };
  },

  computed: {
    measures: function measures() {
      return this.$store.state.measures.measures;
    }
  },
  methods: {
    initialize: function initialize() {
      var _this = this;

      this.configService.checkConfig().then(function (_) {
        _this.measureService.checkMeasures().then(function (_) {
          _this.dataService.checkAllFiles().then(function (_) {
            _this.measureService.updateMeasures();
          });
        });
      });
    }
  },
  created: function created() {
    this.initialize();
  },

  components: {
    'dashboard-thumbnail': __WEBPACK_IMPORTED_MODULE_0__components_DashboardThumbnail_vue___default.a
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ErrorBadge_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ErrorBadge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_ErrorBadge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sparkline_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sparkline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sparkline_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    measure: { type: Object, required: true }
  },
  data: function data() {
    return {
      isExpanded: false
    };
  },

  methods: {
    heightEnterAnimation: function heightEnterAnimation(el, done) {
      /* istanbul ignore next */
      this.heightAnimation(el, done, 0, true);
    },
    heightLeaveAnimation: function heightLeaveAnimation(el, done) {
      /* istanbul ignore next */
      this.heightAnimation(el, done, 100, false);
    },
    heightAnimation: function heightAnimation(el, done, start, expand) {
      /* istanbul ignore next */
      var counter = 0;
      /* istanbul ignore next */
      var interval = setInterval(function () {
        var increment = (expand ? 1 : -1) * counter * 5;
        el.style.maxHeight = start + increment + 'px';
        counter++;
        if (counter > 20) {
          clearInterval(interval);
          done();
        }
      }, 20);
    }
  },
  computed: {
    narrativeId: function narrativeId() {
      /* istanbul ignore else */
      if (this.measure) {
        return 'narrtext_' + this.measure.id;
      }
    }
  },
  components: {
    'error-badge': __WEBPACK_IMPORTED_MODULE_0__common_ErrorBadge_vue___default.a,
    sparkline: __WEBPACK_IMPORTED_MODULE_1__Sparkline_vue___default.a
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: String,
    history: { type: Array, required: true }
  },
  data: function data() {
    return {
      width: 100,
      height: 30,
      margin: 3
    };
  },

  methods: {
    draw: function draw() {
      var _this = this;

      var points = '';
      if (this.history) {
        var xSpacing = this.history.length > 1 ? this.width / (this.history.length - 1) : 0;
        points = this.normalizeData(this.history).map(function (d) {
          return d * (_this.height - 2 * _this.margin) + _this.margin;
        }) // scale y values
        .map(function (d, i) {
          return { x: i * xSpacing, y: d };
        }) // apply x spacing
        .map(function (d) {
          return d.x + ',' + d.y;
        }).join(' '); // convert to string containing coords
      }
      return points;
    },
    normalizeData: function normalizeData(data) {
      var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
      var min = Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
      return data.map(function (d) {
        return (d - min) / (max - min);
      });
    }
  },
  computed: {
    points: function points() {
      return this.draw();
    },
    gradientId: function gradientId() {
      return 'gradient_' + this.id;
    },
    sparklineId: function sparklineId() {
      return 'sparkline_' + this.id;
    },
    fill: function fill() {
      return 'url(#gradient_' + this.id + ')';
    },
    mask: function mask() {
      return 'url(#sparkline_' + this.id + ')';
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(72);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isCollapsed: true,
      panelMutation: 'TOGGLE_DOCS_PANEL'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    openDocSidebar: function openDocSidebar() {
      this.$store.commit('TOGGLE_DOCS_PANEL');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])({
    // openDocSidebar: `${this.panelMutation}`                     // this does not work
    openDocSidebar2: function openDocSidebar2(commit) {
      commit(this.panelMutation);
    }
  })),
  computed: {
    // docsPanelIsOpen() {
    //   return this.$store.state.ui.docsPanelIsOpen
    // },
    currentUser: function currentUser() {
      return this.$store.state.user.currentUser;
    },
    isAuthenticated: function isAuthenticated() {
      return this.currentUser;
    },
    userRoute: function userRoute() {
      return this.isAuthenticated ? '/profile' : '/login';
    }
  }
});

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(212),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(206),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
  __webpack_require__(160)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(211),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-720e9592",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(156)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(208),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b0f1898",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-splitter",
    style: ({
      cursor: _vm.cursor,
      userSelect: _vm.userSelect,
      flexDirection: _vm.flexDirection
    }),
    on: {
      "mouseup": _vm.onUp,
      "mousemove": _vm.onMouseMove,
      "touchmove": _vm.onMove,
      "touchend": _vm.onUp
    }
  }, [(_vm.showLeft) ? _c('div', {
    staticClass: "left-pane splitter-pane",
    style: (_vm.leftPaneStyle)
  }, [_vm._t("left-pane")], 2) : _vm._e(), _vm._v(" "), (_vm.showLeft && _vm.showRight) ? _c('div', {
    staticClass: "splitter",
    class: {
      active: _vm.active
    },
    style: (_vm.splitterStyle),
    on: {
      "mousedown": _vm.onDown,
      "click": _vm.onClick,
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.onDown($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRight) ? _c('div', {
    staticClass: "right-pane splitter-pane",
    style: (_vm.rightPaneStyle)
  }, [_vm._t("right-pane")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sparkline",
    style: ({
      'height': _vm.height
    }),
    attrs: {
      "id": _vm.id
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-top": "8"
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": _vm.gradientId,
      "x1": "0",
      "x2": "0",
      "y1": "1",
      "y2": "0"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "10%",
      "stop-color": "#c6e48b"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "33%",
      "stop-color": "#7bc96f"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "66%",
      "stop-color": "#239a3b"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "90%",
      "stop-color": "#196127"
    }
  })], 1), _vm._v(" "), _c('mask', {
    attrs: {
      "id": _vm.sparklineId,
      "x": "0",
      "y": "0",
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polyline', {
    attrs: {
      "transform": 'translate(0, ' + _vm.height + ') scale(1,-1)',
      "points": _vm.points,
      "fill": "transparent",
      "stroke": "#8cc665",
      "stroke-width": "2"
    }
  })])], 1), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(0, 1.0)"
    }
  }, [_c('rect', {
    staticStyle: {
      "stroke": "none"
    },
    style: ({
      fill: _vm.fill,
      mask: _vm.mask
    }),
    attrs: {
      "x": "0",
      "y": "-2",
      "width": _vm.width,
      "height": _vm.height
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default navbar-inverse"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#myNavbar",
      "aria-controls": "myNavbar"
    },
    on: {
      "click": function($event) {
        _vm.isCollapsed = !_vm.isCollapsed
      }
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "id": "covered",
      "href": "/"
    }
  }, [_vm._v("Migration Workbench")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    class: { in: !_vm.isCollapsed
    },
    attrs: {
      "id": "myNavbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/validations",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Validations")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/referentials",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Referentials")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Clinics'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Clinics")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tasks",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Team Tasks")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "#",
      "tag": "li",
      "active-class": "active"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDocSidebar($event)
      }
    }
  }, [_c('a', [_vm._v("About")])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: _vm.userRoute
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [(!_vm.isAuthenticated) ? _c('a', [_c('span', {
    staticClass: "fa fa-lg fa-sign-in"
  }), _vm._v(" Login")]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('a', [_c('span', {
    staticClass: "fa fa-lg fa-user"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.currentUser.firstName))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.currentUser.lastName))])]) : _vm._e()])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.metric != null) ? _c('span', {
    staticClass: "error-badge badge pull-right",
    class: _vm.item.badgeColor || _vm.item.color
  }, [_vm._v("\n  " + _vm._s(_vm.item.metric) + " " + _vm._s(_vm.units) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('splitter', {
    attrs: {
      "config": _vm.splitterConfig,
      "showLeft": _vm.docsPanelIsOpen
    },
    on: {
      "resize": _vm.onResize
    }
  }, [_c('template', {
    slot: "left-pane"
  }, [_c('div', {
    staticClass: "docs",
    style: (_vm.docsPanelStyle)
  }, [_c('mwb-about')], 1)]), _vm._v(" "), _c('template', {
    slot: "right-pane"
  }, [_c('div', {
    staticClass: "content container-fluid"
  }, [_c('mwb-navigation'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "well well-sm hoverwell thumbnail"
  }, [_c('div', {
    staticClass: "metric row"
  }, [_c('router-link', {
    staticClass: "measure",
    attrs: {
      "to": '/' + _vm.measure.link
    }
  }, [_c('i', {
    staticClass: "measure-icon fa fa-lg",
    class: _vm.measure.icon,
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.measure.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "filler"
  }), _vm._v(" "), _c('sparkline', {
    staticClass: "sparkline",
    attrs: {
      "id": _vm.measure.id,
      "history": _vm.measure.history
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-badge-outer"
  }, [_c('error-badge', {
    attrs: {
      "item": _vm.measure
    }
  })], 1)], 1), _vm._v(" "), (_vm.measure.narrative) ? _c('div', {
    staticClass: "narrative row"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade",
      "type": "animation"
    },
    on: {
      "enter": _vm.heightEnterAnimation,
      "leave": _vm.heightLeaveAnimation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExpanded),
      expression: "isExpanded"
    }],
    staticClass: "narrative-text-container",
    attrs: {
      "id": _vm.narrativeId
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "narrative-text"
  }, [_vm._v(_vm._s(_vm.measure.narrative))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.measure.narrative) ? _c('a', {
    staticClass: "narrative-button",
    on: {
      "click": function($event) {
        _vm.isExpanded = !_vm.isExpanded
      }
    }
  }, [_c('i', {
    staticClass: "narrative-icon fa",
    class: {
      'fa-chevron-down': !_vm.isExpanded, 'fa-chevron-up': _vm.isExpanded
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 400 400",
      "version": "1.1"
    }
  }, [_c('defs', {
    attrs: {
      "id": "defs6"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
      "id": "g10"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(178.0626,235.0086)",
      "id": "g12"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#4dba87",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "id": "path14",
      "d": "M 0,0 -22.669,-39.264 -45.338,0 h -75.491 L -22.669,-170.017 75.491,0 Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(178.0626,235.0086)",
      "id": "g16"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#435466",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "id": "path18",
      "d": "M 0,0 -22.669,-39.264 -45.338,0 H -81.565 L -22.669,-102.01 36.227,0 Z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "docs"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "doclist"
  }, [_vm._l((_vm.docs), function(doc, index) {
    return (!_vm.currentDoc) ? _c('div', {
      key: index
    }, [_c('foldable', {
      attrs: {
        "minHeight": 50,
        "async": ""
      },
      on: {
        "toggle": function($event) {
          _vm.selectDoc(index, $event)
        }
      }
    }, [_c('div', {
      staticClass: "doc",
      style: ({
        'background-color': doc.isCollapsed ? 'lightgrey' : 'ghostwhite'
      }),
      attrs: {
        "id": 'doc' + index
      },
      domProps: {
        "innerHTML": _vm._s(doc.html)
      }
    })]), _vm._v(" "), _c('hr')], 1) : _vm._e()
  }), _vm._v(" "), (_vm.currentDoc) ? _c('div', {
    staticClass: "currentDoc"
  }, [_c('button', {
    staticClass: "close pull-right",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeDoc()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentDoc.html)
    }
  })]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('span', [_c('i', {
    staticClass: "fa fa-lg fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(" Documentation")])]), _vm._v(" "), _c('hr')])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-foldable"
  }, [_c('div', {
    ref: "container",
    staticClass: "vue-foldable-container",
    style: ({
      maxHeight: _vm.currentMaxHeight + 'px'
    })
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.noMask) ? _c('div', {
    staticClass: "vue-foldable-mask",
    class: {
      'collapsed': _vm.collapsed
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("view-more", [(_vm.reachThreshold) ? _c('div', {
    staticClass: "vue-foldable-view-more",
    class: {
      'collapsed': _vm.collapsed
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('VueIcon', {
    staticClass: "vue-foldable-icon",
    class: {
      'collapsed': _vm.collapsed
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "vue-foldable-text"
  }, [_vm._v("\n        " + _vm._s(_vm.collapsed ? 'View more' : 'Collapse') + "\n      ")])], 1) : _vm._e()], {
    toggle: _vm.toggle,
    collapsed: _vm.collapsed
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.title) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Summary of errors, load failures, clinic matching, team tasks")]), _vm._v(" "), _c('hr', {
    staticClass: "titles-rule"
  }), _vm._v(" "), _c('div', {
    staticClass: "thumbnails"
  }, _vm._l((_vm.measures), function(measure) {
    return _c('div', {
      key: measure.id,
      staticClass: "dashboard-thumbnail-outer"
    }, [_c('dashboard-thumbnail', {
      attrs: {
        "measure": measure
      }
    })], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 216 */,
/* 217 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[93]);


// WEBPACK FOOTER //
// static/js/app.665ce7d2073bcc5525d6.js